import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { SheetsDisplayGridRowDataFragmentGql } from './SheetsDisplayGridRowFragmentGql';

export const VirtualConnectionTableDownstreamSheetsFilteredByColumnQueryGql: DocumentNode = gql`
query VirtualConnectionTableDownstreamSheetsFilteredByColumnQuery(
  $vizportalUrlId: String!,
  $selectedColumnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: SheetSortOrder!
) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    columnsConnection(filter: { id: $selectedColumnId }) {
      nodes {
        downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...SheetsDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${SheetsDisplayGridRowDataFragmentGql}
`;
